import React, { useState, forwardRef } from "react";
import DatePicker, {
  CalendarContainer,
  registerLocale,
} from "react-datepicker";
import Select from "react-select";

import th from "date-fns/locale/th";
import dayjs from "dayjs";
registerLocale("th", th);
dayjs.locale("th");

const months = [
  "มกราคม",
  "กุมภาพันธ์",
  "มีนาคม",
  "เมษายน",
  "พฤษภาคม",
  "มิถุนายน",
  "กรกฎาคม",
  "สิงหาคม",
  "กันยายน",
  "ตุลาคม",
  "พฤศจิกายน",
  "ธันวาคม",
];

export const range = (startVal = 0, endVal = 0, increment = 0) => {
  let list = [];
  if (increment <= 0) {
    return list;
  }
  for (let index = startVal; index <= endVal; index = index + increment) {
    list = [...list, index];
  }
  return list;
};

const KPDatePicker = ({
  label,
  control,
  name,
  error,
  minDate,
  maxDate,
  options = 1,
}) => {
  const [pickedDate, setPickedDate] = useState(new Date());

  const yearBoundary = 5;
  const thisYear = dayjs().year();
  const minYear = minDate ? dayjs(minDate).year() : thisYear - yearBoundary;
  const maxYear = maxDate ? dayjs(maxDate).year() : thisYear + yearBoundary;
  const years = range(minYear, maxYear, 1);
  const KPPicker = forwardRef((props, ref) => {
    const { onClick, value } = props;

    let thaiDate = "";
    if (value) {
      const dateValue = dayjs(value);
      const date = dateValue.date();
      const month = dateValue.month() + 1;
      const thaiYear = dateValue.year() + 543;
      const wrappedDisplayFormat = `${date}/${month}/${thaiYear}`;
      thaiDate = wrappedDisplayFormat;
    }

    // if (options === 1) {
    return (
      <div className="w-full flex-1 mx-2">
        <div className="font-bold text-gray-700 text-sm leading-8 uppercase h-6 mx-1 my-2">
          {label}
        </div>
        <div
          onClick={onClick}
          className="bg-white mt-8 my-0 p-2 flex border h-10 border-gray-200 rounded px-2 appearance-none outline-none w-full text-gray-800"
        >
          {thaiDate}
        </div>
      </div>
    );
    // }

    // return (
    //   <div onClick={onClick} className="cursor-pointer">
    //     {label} {thaiDate}
    //   </div>
    // );
  });

  return (
    <DatePicker
      renderCustomHeader={({
        date,
        changeYear,
        changeMonth,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
      }) => (
        <div className="flex mx-auto items-center my-2">
          <button
            className="w-4 mx-4 cursor-pointer"
            onClick={decreaseMonth}
            disabled={prevMonthButtonDisabled}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
                clipRule="evenodd"
              />
            </svg>
          </button>

          <select
            className=" border-darken-3 mr-1 px-1 py-1 border-2"
            value={months[dayjs(date).month()]}
            onChange={({ target: { value } }) =>
              changeMonth(months.indexOf(value))
            }
          >
            {months.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          <select
            className="border-darken-3 ml-1 px-1 py-1 border-2"
            value={dayjs(date).year()}
            onChange={({ target: { value } }) => changeYear(value)}
          >
            {years.map((option) => (
              <option key={option} value={option}>
                {option + 543}
              </option>
            ))}
          </select>

          <button
            className="mx-4 w-4 cursor-pointer"
            onClick={increaseMonth}
            disabled={nextMonthButtonDisabled}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        </div>
      )}
      selected={pickedDate}
      onChange={(date) => setPickedDate(date)}
      customInput={<KPPicker label={label} />}
    />
  );
};

export default KPDatePicker;
